import axios from 'axios';
import MainService from './MainService';

export default class ServiceOrderBookingService extends MainService {
	constructor() {
		super();
		this.url = `${this.apiUrl}/guide-service-order-bookings`;
	}

	filter(filter) {
		return axios.post(this.url+'/filter', filter);
	}

	updateStatus(id, status) {
		return axios.put(`${this.url}/${id}/status`, {status: status});
	}
	updateStatuses(ids, status) {
		return axios.post(`${this.url}/statuses-batch`, {bookingIds: ids, status: status});
  }
}



// WEBPACK FOOTER //
// ./src/service/ServiceOrderBookingService.js